import { Device } from '../../../@types/model/device';
import { useState } from 'react';
import { GoogleMap, InfoWindow, Marker, withGoogleMap } from 'react-google-maps';
import { generatePath } from 'react-router';
import { PATH_DASHBOARD } from 'routes/paths';

import mapSyle from '../../MapStyle';

const iconNormal = {
  url: '/static/icons/giraf/normal_marker.svg'
};
const DonutGreen = {
  url: '/static/donut_green.png'
};
const DonutYellow = {
  url: '/static/donut_yellow.png'
};
const DonutRed = {
  url: '/static/donut_red.png'
};

const MapMiniRepsol = withGoogleMap((props: any) => {
  const markers: any[] = [];
  // @ts-ignore
  const bounds = new window.google.maps.LatLngBounds();

  const [userInteraction, setUserInteraction] = useState<{
    hovered: string | null;
    interacted: boolean;
  }>({
    hovered: null,
    interacted: false
  });
  props.markers.forEach((device: Device) => {
    if (device?.attributes.last_location !== null) {
      let icon = iconNormal;
      let percent: number = 0;
      device?.attributes.last_data?.data.forEach((dat) => {
        switch (dat.name) {
          case 'Percent':
            percent = parseInt(dat.value);
            break;
        }
      });
      if (percent >= 50) icon = DonutGreen;
      else if (percent >= 20) icon = DonutYellow;
      else icon = DonutRed;
      if (device?.guid) {
        markers.push(
          <Marker
            onMouseOver={() =>
              setUserInteraction({
                hovered: device.guid,
                interacted: true
              })
            }
            onMouseOut={() =>
              setUserInteraction({
                hovered: null,
                interacted: true
              })
            }
            key={device.guid}
            position={{
              lat: device?.attributes.last_location.lat,
              lng: device?.attributes.last_location.lon
            }}
            onClick={() => {
              document.location.href = generatePath(PATH_DASHBOARD.end_user.devices.details, {
                guid: device.guid
              });
            }}
            icon={icon}
          >
            {userInteraction.hovered === device.guid ? (
              <InfoWindow options={{ disableAutoPan: true, disableAutoZoom: true }}>
                <span>
                  {device.attributes.name.length > 0
                    ? device.attributes.name
                    : device.attributes.identifier}
                </span>
              </InfoWindow>
            ) : null}
          </Marker>
        );
      }
      if (device) {
        const { lat, lon } = device?.attributes.last_location;
        // @ts-ignore
        const latLng = new window.google.maps.LatLng(parseFloat(lat), parseFloat(lon));
        bounds.extend(latLng);
      }
    }
  });

  return (
    <GoogleMap
      defaultZoom={4}
      defaultCenter={{
        lat: parseFloat(props.markers[0]?.attributes?.last_location?.lat),
        lng: parseFloat(props?.markers[0]?.attributes?.last_location?.lon)
      }}
      options={{
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        styles: mapSyle
      }}
    >
      {markers}
    </GoogleMap>
  );
});

export default MapMiniRepsol;
